var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-12"},[_c('notes',{attrs:{"object-id":_vm.$route.params.id,"api-key":_vm.apiKey}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }